export const SampleAvailabilityIcons = Object.freeze({
  MAXIMUM: "maximum",
  CLOUD_UNAVAILABLE: "cloud-is-unavailable",
  CLOUD: "cloud",
  LOCAL_TOP_LEVEL: "format",
  LOCAL_EXTRACTED: "extracted-files",
  URL: "network-payload",
  DROPPED_FILE: "dropped-file"
});

export const SampleAvailabilityMessages = Object.freeze({
  MAXIMUM: "Sample exceeds max fetch file size",
  AVAILABLE_AND_MAXIMUM:
    "Sample is available for fetch but exceeds max fetch file size",
  CLOUD_UNAVAILABLE: "Sample is not available for fetch",
  CLOUD: "Sample is available for fetch",
  LOCAL: "Local sample",
  LOCAL_TOP_LEVEL: "Top Level Container",
  LOCAL_EXTRACTED: "Extracted File",
  DISABLED_FOR_SAMPLE: "Action unavailable for this sample.",
  URL: "URL Payload",
  DROPPED_FILE: "Dropped File"
});

export const STATUS_CODES = {
  NOT_CHANGED: 304,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403
};
